import axios from 'axios'

export default class YayWebSocket {
  ws: WebSocket

  constructor() {
    this.ws = null
  }

  getWsToken = async (accessToken) => {
    const resp = await axios.get(
      `${window?.gon?.REACT_API_URL}/v1/users/ws_token`,
      {
        headers: {
          Authorization: `bearer ${accessToken}`,
          'X-App-Version': window?.gon?.version,
        },
      }
    )

    return resp.data.token
  }

  connect = async (yayAccessToken) => {
    this.disconnect()
    const token = await this.getWsToken(yayAccessToken)
    this.ws = new WebSocket(
      `${window?.gon?.WS_URL}?token=${token}&app_version=${window?.gon?.version}`
    )
  }

  disconnect = () => {
    if (this.ws !== null && this.ws?.readyState === 1) {
      this.ws.close()
    }
  }

  subscribe = (channel) => {
    if (this.ws === null || this.ws?.readyState !== 1)
      throw new Error('Invalid state: No websocket connection')

    this.ws.send(
      JSON.stringify({
        command: 'subscribe',
        identifier: `{"channel":"${channel}"}`,
      })
    )
  }

  unsubscribe = (channel) => {
    if (this.ws !== null) {
      this.ws.send(
        JSON.stringify({
          command: 'unsubscribe',
          identifier: `{"channel":"${channel}"}`,
        })
      )
    }
  }
}
